<template>
  <div id="list-nas">
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <span>Nas |</span>
            <v-skeleton-loader
              type="card-heading"
              v-if="nbResults < 0 || global.totalNas < 0"
            ></v-skeleton-loader>
            <span v-else class="ml-1 text-body-1">
              {{ nbResults }} / {{ global.totalNas }}
            </span>
          </v-card-title>
          <v-divider></v-divider>
          <filtres-nas :criteria.sync="criteriaNas"></filtres-nas>
          <v-divider></v-divider>
          <v-card-text>
            <div id="table-nas-container">
              <nas-datatable
                :filterParams="criteriaNas"
                v-on:display:nb-nas="updateNbResults"
              ></nas-datatable>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import NasDatatable from "@/components/Nas/NasDatatable";
import { useTitle } from "@/composables/title";
import FiltresNas from "@/components/Nas/FiltresNas.vue";
import { useNas } from "../composables/nas";
import global from "@/composables/global";
import { ref } from "@vue/composition-api";

export default {
  components: {
    NasDatatable,
    FiltresNas,
  },
  setup() {
    /* Import des API */
    const { setTitle, setIcon } = useTitle();
    const { criteriaNas } = useNas();

    /* Variables */
    const nbResults = ref(-1);

    /* Méthodes */
    const updateNbResults = function (value) {
      nbResults.value = value;
    };

    /* Actions */
    setTitle("NAS");
    setIcon("nas");

    return {
      criteriaNas,
      global,
      nbResults,
      updateNbResults,
    };
  },
};
</script>
